import { Component, ChangeDetectionStrategy, Renderer2, ElementRef, HostListener, ViewChild, Input, ChangeDetectorRef, ContentChildren, forwardRef } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AmdDropdownComponent } from '../dropdown/dropdown.component';
import { AmdInputContainerComponent } from '../input-container/input-container.component';
import { AmdOptionComponent } from '../option/option.component';
export class AmdSelectComponent {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     * @param {?} changeDetectorRef
     */
    constructor(renderer, elementRef, changeDetectorRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.placeholder = '';
        this.label = '';
        this.isContentActive = false;
        this.value = '';
        this.content = '';
        this.propagateChange = (value) => {
            // do nothing
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'tabindex', '0');
        this.content = this.placeholder;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.options.forEach((option) => {
            option.optionClick.subscribe(() => {
                this.value = option.value;
                this.content = option.content;
                this.dropdown.close();
                this.changeDetectorRef.markForCheck();
                this.propagateChange(this.value);
            });
        });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (!value) {
            return;
        }
        this.value = value;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @return {?}
     */
    registerOnTouched() {
        // todo
    }
    /**
     * @return {?}
     */
    onFocus() {
        this.inputContainer.focus();
    }
    /**
     * @return {?}
     */
    onBlur() {
        this.inputContainer.blur();
        this.dropdown.close();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (event.keyCode === ENTER) {
            this.dropdown.toggle();
        }
    }
    /**
     * @return {?}
     */
    onTriggerClicked() {
        this.isContentActive = true;
    }
}
AmdSelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-select',
                template: "<div class=\"amd-select\"> <label *ngIf=\"label\">{{label}}</label> <amd-input-container> <amd-dropdown> <div class=\"amd-select__trigger\" amdDropdownTrigger> <div amdInput>{{content}}</div> </div> <div class=\"amd-select__content amd-menu\" amdDropdownContent> <ng-content></ng-content> </div> </amd-dropdown> </amd-input-container> </div>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => AmdSelectComponent),
                        multi: true,
                    }
                ]
            },] },
];
/**
 * @nocollapse
 */
AmdSelectComponent.ctorParameters = () => [
    { type: Renderer2, },
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
];
AmdSelectComponent.propDecorators = {
    'placeholder': [{ type: Input },],
    'label': [{ type: Input },],
    'dropdown': [{ type: ViewChild, args: [AmdDropdownComponent,] },],
    'inputContainer': [{ type: ViewChild, args: [AmdInputContainerComponent,] },],
    'options': [{ type: ContentChildren, args: [AmdOptionComponent,] },],
    'onFocus': [{ type: HostListener, args: ['focus',] },],
    'onBlur': [{ type: HostListener, args: ['blur',] },],
    'onClick': [{ type: HostListener, args: ['keydown', ['$event'],] },],
};
function AmdSelectComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSelectComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSelectComponent.ctorParameters;
    /** @type {?} */
    AmdSelectComponent.propDecorators;
    /** @type {?} */
    AmdSelectComponent.prototype.placeholder;
    /** @type {?} */
    AmdSelectComponent.prototype.label;
    /** @type {?} */
    AmdSelectComponent.prototype.isContentActive;
    /** @type {?} */
    AmdSelectComponent.prototype.value;
    /** @type {?} */
    AmdSelectComponent.prototype.content;
    /** @type {?} */
    AmdSelectComponent.prototype.dropdown;
    /** @type {?} */
    AmdSelectComponent.prototype.inputContainer;
    /** @type {?} */
    AmdSelectComponent.prototype.options;
    /** @type {?} */
    AmdSelectComponent.prototype.propagateChange;
    /** @type {?} */
    AmdSelectComponent.prototype.renderer;
    /** @type {?} */
    AmdSelectComponent.prototype.elementRef;
    /** @type {?} */
    AmdSelectComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=select.component.js.map
//# sourceMappingURL=select.component.js.map
